import { api } from "api/apiService";

/**
 * Завантажує звіт про очікувані поставки з урахуванням параметрів.
 * @param {object} [filters={}] - Об'єкт з параметрами для фільтрації, сортування та пагінації.
 * @returns {Promise<object>} Проміс, що повертає об'єкт з даними про поставки.
 */
export const fetchSupplyReport = (filters = {}) => {
  const cleanFilters = {};
  // Копіюємо лише ті фільтри, які мають значення, для чистоти URL
  for (const key in filters) {
    const value = filters[key];
    if (value !== null && value !== undefined && value !== "") {
      cleanFilters[key] = value;
    }
  }

  return api.get("/supply-report", cleanFilters);
};
